import React, { useEffect, useState } from 'react'
import { Box, Paper, Typography } from '@mui/material'
import features from '../../data/features.json'

const FeaturesList = (props) => {

  const [ featuresToRender, setFeaturesToRender ] = useState([]);

  useEffect(() => {

    switch (props?.isPro) {
      case undefined:
        setFeaturesToRender(features);
        break;
      case true:
        const proFeatures = features.filter((feature) => feature.isPro === true);
        setFeaturesToRender(proFeatures);
        break;
      case false:
        const basicFeatures = features.filter((feature) => feature.isPro === false);
        setFeaturesToRender(basicFeatures);
        break;
      default:
        setFeaturesToRender(features);
        break;
    }
    
    return () => {}

  }, [props?.isPro]);

  return (
    <Box>
      <Box>
        {
          featuresToRender.map(feature => (
            <Box key={feature?.id}>
              <Paper sx={{alignItems: "center", display: "flex", my:1, p:1,}}>
                <Paper
                  component="div"
                  sx={{
                    alignItems: "center",
                    backgroundColor: feature?.background_color,
                    display: "flex",
                    justifyContent: "center",
                    height: 60, width: 60,
                    maxHeight: 60, maxWidth: 60,
                    minHeight: 60, minWidth: 60,
                  }}
                >
                  <Box
                    component="img"
                    height={24}
                    src={
                      process.env.NODE_ENV === 'development' ? 
                      "/assets/svg/icons/white/" + feature?.slug + ".svg" :
                      "/wp-content/themes/personal-architect/assets/svg/icons/white/" + feature?.slug + ".svg"
                    }
                    width={24}
                  ></Box>
                </Paper>
                <Box sx={{ml:2,}}>
                  <Box sx={{alignItems: "center", display: "flex",}}>
                    <Typography component="h2" fontWeight={600} variant="h6">{feature?.name}</Typography>
                    { feature?.isPro === true ? (
                      <Box sx={{ml:1,}}>
                        <Typography sx={{ color: "#fff", backgroundColor: "#b71c1c", borderRadius: "4px", pl: .8, pr: .8,}}>Pro</Typography>
                      </Box>
                    ) : null }
                  </Box>
                  <Typography>{feature?.short_description}</Typography>
                </Box>
              </Paper>
            </Box>
          ))
        }
      </Box>
    </Box>
  )
}

export default FeaturesList